import { render, staticRenderFns } from "./TeleMarketAttachment.vue?vue&type=template&id=f0586bb8&scoped=true"
import script from "./TeleMarketAttachment.vue?vue&type=script&lang=js"
export * from "./TeleMarketAttachment.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketAttachment.vue?vue&type=style&index=0&id=f0586bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0586bb8",
  null
  
)

export default component.exports